import CalendarImg from "public/migrationToMost/calendar.png";
import AnalysisImg from "public/migrationToMost/analysis.png";
import VideoImg from "public/migrationToMost/video.png";
import { MAIN_ROUTES } from "@/constants/routes";

export const MIGRATION_CONSTANTS = {
  title: "Ready to Migrate with Confidence?",
  items: [
    {
      image: CalendarImg,
      title: "Schedule a Free Migration Assessment",
      text: "Get expert insights into your migration readiness with our comprehensive assessment.",
      button: {
        label: "Schedule Now",
        link: MAIN_ROUTES.BOOK_A_CONSULTATION,
      },
    },
    {
      image: AnalysisImg,
      title: "Request a Cost Comparison of AWS EC2 vs Zadara",
      text: "Compare AWS EC2 vs Zadara costs and see how much you could save.",
      button: {
        label: "Get Comparison",
        link: MAIN_ROUTES.BOOK_A_CONSULTATION,
      },
    },
    {
      image: VideoImg,
      title: "Book a Live Strategy Call",
      text: "Discuss your migration strategy with our experts in a personalized session.",
      button: {
        label: "Book Call",
        link: MAIN_ROUTES.BOOK_A_CONSULTATION,
      },
    },
  ],
};
